import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import QuestionText from '../components/QuestionText';
import FormControl from '@material-ui/core/FormControl';
import Button from '../../../components/Button.js';
import Select from 'react-select';
import { uniqueValuesFromObjectArray } from '../../../lib/util';

// Convert services taxonomy data to react-select input
const taxonomyToSelectInput = (services) => {
  const flatServices = uniqueValuesFromObjectArray(services, 'children').flat();
  const output = flatServices.map(item => ({value: item.name, label: item.name}));
  output.push({value: 'Other', label: 'Other'}); // add misc category
  return output;
};

// Convert selected items to store output
const selectedToStoreOutput = (selected) => {
  if (selected === null) {
    return null;
  } else {
    // return selected.map(item => ({name: item.value}));
    return selected.map(item => {
      let newItem = {name: item.value};
      if ('amount' in item) {
        newItem['amount'] = item.amount;
      }
      return newItem;
    });
  }
};

// Convert store items to react-select default values
const storeDataToDefaultSelection = (items) => {
  if (items.length === 0) {
    return null;
  }
  return items.map(item => {
    let newItem = {
      value: item.name,
      label: item.name
    };
    if ('amount' in item) {
      newItem['amount'] = item.amount;
    }
    return newItem;
  });
};

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    margin: 0,
    backgroundColor: theme.palette.common.white,
  },
  select: {
    '& .select__control': {
      padding: '0.5rem',
      '&:hover': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
    '& .select__control--is-focused': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    '& .select__control--menu-is-open': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    '& .select__multi-value__label': {
      fontSize: '1.1rem',
    },
  },
  button: {
    padding: '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ServiceSubsetSelectionQuestion = ({data, handleAnswer, services}) => {
  const classes = useStyles();
  const serviceOptions = taxonomyToSelectInput(services);
  const defaultValue = storeDataToDefaultSelection(data.services);
  const [selections, setSelections] = React.useState(selectedToStoreOutput(defaultValue));

  const onChange = (selected) => {
    setSelections(selectedToStoreOutput(selected));
  };

  const handleSubmit = () => {
    handleAnswer('services', selections);
  };

  React.useEffect(() => {
    // If there is only 1 service option, skip this question
    if (serviceOptions.length === 1) {
      handleAnswer('services', selections);
    }
  }, [serviceOptions, selections, handleAnswer]);

  return (
    <React.Fragment>
      <QuestionText>
        Please tell us which of this provider&apos;s service(s) you are looking for.
      </QuestionText>
      <FormControl className={classes.formControl}>
        <Select
          isMulti
          name="Options"
          defaultValue={defaultValue}
          options={serviceOptions}
          classNamePrefix="select"
          onChange={onChange}
          className={classes.select}
          placeholder="Start typing or search from the list..."
        />
      </FormControl>
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
          disabled={selections === null}
        />
      </div>
    </React.Fragment>
  );
};

ServiceSubsetSelectionQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
  services: PropTypes.array.isRequired,
};

export default ServiceSubsetSelectionQuestion;
